var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "top-line",
    x: 10,
    y: 12,
    width: 30,
    height: 4,
    rx: 3,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "middle-line",
    x: 10,
    y: 22,
    width: 30,
    height: 4,
    rx: 3,
    fill: "#000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "bottom-line",
    x: 10,
    y: 32,
    width: 30,
    height: 4,
    rx: 3,
    fill: "#000"
  })));
};
export default SvgHamburgerMenu;